module.exports = __webpack_public_path__ + "img/IT0000563943806.f3ff411d.png";